export const actionTypes = {
  SET_SUBJECT: 'SET_SUBJECT',
  SET_RECIPIENT: 'SET_RECIPIENT',
  SET_CC_RECIPIENTS: 'SET_CC_RECIPIENTS',
  SET_BODY: 'SET_BODY'
} as const

export function setSubject(subject?: string) {
  return { type: actionTypes.SET_SUBJECT, subject }
}

export function setRecipient(recipient?: string) {
  return { type: actionTypes.SET_RECIPIENT, recipient }
}

export function setCCRecipient(ccRecipient: string) {
  return { type: actionTypes.SET_CC_RECIPIENTS, ccRecipient }
}

export function setBody(body: string) {
  return { type: actionTypes.SET_BODY, body }
}

export type Action = ReturnType<
  typeof setSubject | typeof setRecipient | typeof setCCRecipient | typeof setBody
>
